module.exports = __webpack_public_path__ + "img/Buy(Button).c71a4b6e.svg";